import { useState } from 'react';
import { BillingApi } from '#shared/components/AccountAndBilling/types';

// The write op is host-supplied (account vs partner endpoint) — the (c) interface. This hook only owns
// the saving state and the Success check.
export default function useSetDefaultPaymentMethod(setDefaultPaymentMethodOp: BillingApi['setDefaultPaymentMethod']) {
  const [saving, setSaving] = useState(false);

  const setDefaultPaymentMethod: BillingApi['setDefaultPaymentMethod'] = async (params) => {
    try {
      setSaving(true);
      const res = await setDefaultPaymentMethodOp(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSaving(false);
    }
  };

  return { saving, setDefaultPaymentMethod };
}
